module.exports = __webpack_public_path__ + "img/USA_NUTS.7ee00b71.png";